import { Component, OnInit, Output, EventEmitter } from '@angular/core';

import { AuthService } from './../../../../../services/auth.service';
import { MemberService } from './../../../../../rest/api/member.service';

@Component({
  selector: 'app-unsubscribe-camera',
  templateUrl: './unsubscribe-camera.component.html',
  styleUrls: ['./unsubscribe-camera.component.scss']
})
export class UnsubscribeCameraComponent implements OnInit {
  @Output() removeCameraSubscriptionEmit = new EventEmitter();

  accessToken: any;
  cameraPlansData: any;
  cameraPlansLoader = true;

  isSubmitted = false;

  errors = [];
  successMsg: string;
  errorMsg: string;
  constructor(
    private authService: AuthService,
    public memberService: MemberService,
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
  }

  removeCameraSubscription() {

    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.memberService.removeCameraSubscription(this.accessToken).subscribe(response => {
      this.successMsg = 'You have successfully unsubscribed camera features.';
      this.isSubmitted = false;
      const thisobject = this;
      setTimeout(() => {
        this.resetErrors();
        thisobject.removeCameraSubscriptionEmit.emit(true);
      }, 1000);
    }, err => {
      this.isSubmitted = false;
      this.handleErrors(err);
    });
  }

  handleErrors(err) {
    if (err.error && err.error.errors) {
      this.errors = err.error.errors;
    } else if (err.error && err.error.error) {
      this.errorMsg = err.error.error;
    } else {
      this.errorMsg = 'There was error while creating space.';
    }
  }

  resetErrors() {
    this.errors = [];
    this.errorMsg = undefined;
    this.successMsg = undefined;
  }

}
